import MobileConsole from "./MobileConsole"
const VueMobileConsolePlugin = {};
let instance = null;
VueMobileConsolePlugin.install = function(Vue) {
  if (!instance) {
    setTimeout(() => {
      const app = document.getElementById('app')
      let VueMobileConsole = Vue.extend(MobileConsole);
      instance = new VueMobileConsole({
        el: document.createElement('div'),
      })
      app.appendChild(instance.$el)
    }, 1000)
  }
};
export default VueMobileConsolePlugin;
